<template>
  <div class="page-content term-grades-class">
    <div class="student-list">
      <div class="class-info">
        <div class="class-title">
          <span class="back" @click="back"> ← </span>
          <a-divider type="vertical" />
          <span>{{ classInfo.name }}</span>
        </div>
        <a-button
          v-if="handleRightsList.includes('编辑')"
          :disabled="submitDisabled"
          @click="confirmSubmitGrade"
        >
          {{ $t('handle.submit') }}
        </a-button>
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :rowKey="(record) => record.id"
        :loading="studentTableLoading"
        :dataSource="studentDataSource"
        :pagination="false"
        :rowClassName="
          (record) => (studentId === record.id ? 'selected-row' : '')
        "
        :customRow="
          (record) => {
            return {
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  if (studentId === record.id) {
                    return
                  }
                  studentInfo = record
                  studentId = record.id
                },
              },
            }
          }
        "
      >
        <a-table-column
          :title="$t('public.studentId')"
          dataIndex="studentNo"
          :sorter="sorterStudentNo"
        ></a-table-column>

        <a-table-column
          :title="$t('public.name')"
          dataIndex="name"
          :sorter="sorterName"
        >
          <template slot-scope="name, record">
            {{ record.name }}
            <span
              class="name"
              :class="
                record.studentStatus == 3
                  ? 'QS'
                  : record.studentStatus == 4
                  ? 'DO'
                  : 'GRA'
              "
              v-if="
                record.studentStatus == 3 ||
                record.studentStatus == 4 ||
                record.studentStatus == 5
              "
              >{{
                record.studentStatus == 3
                  ? $t('public.quitSchool')
                  : record.studentStatus == 4
                  ? $t('public.dropOut')
                  : record.studentStatus == 5
                  ? $t('public.graduation')
                  : ''
              }}</span
            >
          </template>
        </a-table-column>

        <a-table-column
          :title="$t('public.englishName')"
          dataIndex="englishName"
          :sorter="sorterEnglishName"
        >
          <template slot-scope="englishName, record">
            {{ record.surname }} {{ record.givenName }} ({{
              record.englishName
            }})
          </template>
        </a-table-column>

        <a-table-column :title="$t('public.status')" dataIndex="complete">
          <template slot-scope="complete, record">
            {{ complete }} / {{ record.incomplete + complete }}
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="student-grade" v-if="!!studentId">
      <div class="search-wrap">
        <div class="grade-title">
          {{ examInfo.label }} of Grade {{ classInfo.grade }}
        </div>
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">{{ $t('public.academicYear') }}</div>
            <a-select
              showSearch
              v-model="academic"
              style="width: 100%"
              :placeholder="$t('public.academicYear')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in academicYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.exam') }}</div>
            <a-select
              showSearch
              v-model="exam"
              style="width: 100%"
              :placeholder="$t('public.exam')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in examList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <div class="cover-header"></div>
      <div class="cover-content">
        <div class="table-title student-name">
          {{ studentInfo.name }} {{ studentInfo.surname }}
          {{ studentInfo.givenName }} ({{ studentInfo.englishName }})
        </div>

        <!-- 表格 -->
        <a-table
          size="middle"
          :rowKey="(record) => record.id"
          :loading="tableLoading"
          :dataSource="dataSource"
          :pagination="false"
        >
          <a-table-column
            :width="180"
            :title="$t('public.subject')"
            dataIndex="name"
            :customCell="
              () => {
                return {
                  class: 'subject-font',
                }
              }
            "
          ></a-table-column>

          <a-table-column
            v-if="userInfo.role.type !== 'SubjectTeacher'"
            :width="180"
            :title="$t('public.teacher')"
            dataIndex="teacher"
          ></a-table-column>

          <a-table-column
            :width="100"
            :title="$t('public.score')"
            dataIndex="score"
            :customCell="
              () => {
                return {
                  class: 'subject-font',
                }
              }
            "
          >
            <template slot-scope="score, record">
              {{ record.recordStatus === 4 ? 'N/A' : score }}
            </template>
          </a-table-column>

          <a-table-column
            :title="$t('public.comments')"
            dataIndex="comments"
          ></a-table-column>

          <a-table-column
            :width="120"
            :title="$t('public.operate')"
            align="right"
            dataIndex="handles"
            v-if="handleRightsList.includes('编辑')"
          >
            <template slot-scope="handles, record">
              <a
                href="javascript:;"
                v-if="record.gradeStatus === 0"
                @click="editItem(record)"
              >
                {{ $t('handle.edit') }}
              </a>
              <a
                href="javascript:;"
                v-else-if="
                  record.gradeStatus === 1 ||
                  record.gradeStatus === 2 ||
                  record.gradeStatus === 4
                "
                @click="editItem(record)"
              >
                {{ $t('handle.reedit') }}
              </a>
              <span class="grade-status" v-else-if="record.gradeStatus === 5">
                {{ $t('public.checkPending') }}
              </span>
            </template>
          </a-table-column>
        </a-table>

        <template
          v-if="
            handleRightsList.includes('班主任反馈') &&
            classInfo.classAdviserStatus === 1
          "
        >
          <div class="table-list-title">
            {{ $t('public.classAdvisorFeedback') }}
          </div>

          <a-table
            size="middle"
            :rowKey="(record, index) => index"
            :loading="feedbackTableLoading"
            :dataSource="feedbackDataSource"
            :pagination="false"
          >
            <a-table-column
              :title="$t('public.comments')"
              dataIndex="comments"
            ></a-table-column>

            <a-table-column
              width="80px"
              align="right"
              :title="$t('public.operate')"
              dataIndex="operate"
            >
              <template slot-scope="handle, record">
                <a
                  href="javascript:;"
                  v-if="record.submitStatus === 0"
                  @click="editFeedback(record)"
                >
                  {{ $t('handle.edit') }}
                </a>
                <a
                  href="javascript:;"
                  v-else-if="record.submitStatus === 1"
                  @click="editFeedback(record)"
                >
                  {{ $t('handle.reedit') }}
                </a>
              </template>
            </a-table-column>
          </a-table>
        </template>
      </div>
    </div>

    <a-modal
      :title="$t('public.edit', { content: $t('public.grades_lower') })"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form :form="form">
        <a-form-item
          :label="$t('public.score')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-input-number
            :placeholder="$t('public.score_lower')"
            v-decorator="[
              'score',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.score_lower'),
                    }),
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label="$t('public.comments')"
          :extra="`${
            form.getFieldValue('comments')
              ? form.getFieldValue('comments').length
              : '0'
          }/1000`"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-textarea
            maxLength="1000"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="[
              'comments',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.comments_lower'),
                    }),
                  },
                ],
              },
            ]"
          >
          </a-textarea>
        </a-form-item>

        <!-- <a-form-item
          v-if="gradeStatus"
          :label="$t('report.verificationCode')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="{ span: 10 }"
        >
          <a-input-search
            :placeholder="$t('report.verificationCode')"
            v-decorator="[
              'verificationCode',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('report.verificationCode_lower')
                    })
                  }
                ]
              }
            ]"
            @search="getMailCode"
          >
            <a-button :disabled="haveCode" type="primary" slot="enterButton">
              {{ haveCode ? codeTime : $t('handle.send') }}
            </a-button>
          </a-input-search>
        </a-form-item> -->

        <a-alert
          v-if="gradeStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        />
      </a-form>
    </a-modal>

    <a-modal
      :title="
        $t('public.edit', { content: $t('public.classAdvisorFeedback_lower') })
      "
      v-model="feedbackModalVisible"
      :confirmLoading="feedbackModalLoading"
      :afterClose="feedbackAfterClose"
      @ok="feedbackOk"
    >
      <a-form
        :form="feedbackForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
      >
        <a-form-item
          :label="$t('public.comments')"
          :extra="`${
            feedbackForm.getFieldValue('comments')
              ? feedbackForm.getFieldValue('comments').length
              : '0'
          }/1000`"
        >
          <a-textarea
            maxLength="1000"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="[
              'comments',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.comments_lower'),
                    }),
                  },
                ],
              },
            ]"
          >
          </a-textarea>
        </a-form-item>

        <a-alert
          v-if="gradeStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        />
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      campusId: localStorage.getItem('campusId'),
      classId: this.$route.params.classId,
      classInfo: {},
      submitDisabled: true,

      // 学生
      studentTableLoading: false,
      studentDataSource: [],

      studentInfo: {},
      studentId: '',
      // 学年
      academic: undefined,
      // 考试
      exam: undefined,
      examInfo: {},

      // 课程
      tableLoading: false,
      dataSource: [],

      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 20 },
      },

      gradeId: '',
      courseId: '',
      gradeStatus: false,

      // CODE_TIME: 60,
      // codeTime: 60,
      // haveCode: false

      feedbackTableLoading: false,
      feedbackDataSource: [],

      // 编辑反馈
      feedbackModalVisible: false,
      feedbackModalLoading: false,
      feedbackForm: this.$form.createForm(this),
      feedbackId: '',
    }
  },

  computed: {
    ...mapGetters([
      'handleRightsList',
      'userInfo',
      'userId',
      'academicYearList',
      'examList',
    ]),
  },

  watch: {
    academic() {
      this.getDataSource()
      this.getFeedback()
      this.getStudentDataSource()
    },

    exam(val) {
      for (const item of this.examList) {
        if (item.value === val) {
          this.examInfo = item
        }
      }
      this.getDataSource()
      this.getFeedback()
      this.getStudentDataSource()
    },

    studentId() {
      this.getDataSource()
      this.getFeedback()
    },
  },

  created() {
    this.getClassesDetail()
    this.selectYearSemester()
  },

  methods: {
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 班级详情
    getClassesDetail() {
      this.$http(this.$api.GETCLASSESDETAIL, {
        id: this.classId,
      }).then((r) => {
        this.classInfo = r.data
      })
    },

    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }

      // 默认考试
      if (month >= 9) {
        this.exam = this.examList[0].value
      } else if (month >= 6) {
        this.exam = this.examList[3].value
      } else if (month >= 3) {
        this.exam = this.examList[2].value
      } else {
        this.exam = this.examList[1].value
      }
    },

    // 班级里学生
    getStudentDataSource() {
      this.studentTableLoading = true
      this.$http(this.$api.GETLISTBYCLASSID, {
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
      }).then((r) => {
        this.studentDataSource = r.data || []
        this.studentTableLoading = false
        if (!this.studentId && this.studentDataSource.length > 0) {
          this.studentInfo = this.studentDataSource[0]
          this.studentId = this.studentDataSource[0].id
        }
      })
    },

    // 提交状态
    checkSubmitStatus() {
      this.$http(this.$api.CHECKSUBMITSTATUS, {
        campusId: this.campusId,
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
        userId: this.userId,
      }).then((r) => {
        if (r.data === 0) {
          this.submitDisabled = false
        } else {
          this.submitDisabled = true
        }
      })
    },

    back() {
      this.$router.back()
    },

    // 提交班级成绩
    confirmSubmitGrade() {
      this.$confirm({
        title: this.$t('handle.submit'),
        content: this.$t('report.submitGradeTip'),
        onOk: () => {
          this.submitGrade()
        },
        onCancel() {},
      })
    },

    submitGrade() {
      this.submitDisabled = true
      this.$http(this.$api.SUBMITGRADE, {
        campusId: this.campusId, // 学习中心ID
        classId: this.classId,
        academic: this.academic,
        term: this.exam,
        userId: this.userId,
        courseIds: this.dataSource.map((item) => item.id).join(','),
      }).then(() => {
        this.checkSubmitStatus()
        this.getDataSource()
        this.$message.success(this.$t('public.saveSuccess'))
      })
    },

    // 学生科目成绩
    getDataSource() {
      if (this.academic && this.exam && this.studentId) {
        this.tableLoading = true
        this.$http(this.$api.GETTERMEXAMCOURSEBYSTUDENTID, {
          campusId: this.campusId, // 学习中心ID
          classId: this.classId,
          academic: this.academic,
          term: this.exam,
          studentId: this.studentId,
          userId: this.userId,
        }).then((r) => {
          this.checkSubmitStatus()
          this.dataSource = r.data.map((item) => {
            if (item.grade) {
              return {
                ...item,
                gradeId: item.grade.id,
                gradeStatus: item.grade.gradeStatus,
                recordStatus: item.grade.recordStatus,
                score: item.grade.score,
                comments: item.grade.comments,
              }
            } else {
              return {
                ...item,
                gradeStatus: 0,
                recordStatus: 0,
              }
            }
          })
          this.tableLoading = false
        })
      }
    },

    editItem(record) {
      this.gradeId = record.gradeId
      this.courseId = record.id
      this.gradeStatus =
        record.gradeStatus === 1 ||
        record.gradeStatus === 2 ||
        record.gradeStatus === 4
      this.modalVisible = true
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          score: record.score,
          comments: record.comments,
        })
      })
    },

    // getMailCode() {
    //   this.haveCode = true
    //   this.codeTime = this.CODE_TIME
    //   this.setCodeTime()
    //   this.$http(this.$api.SENDEMAILCODE, {
    //     userId: this.userId,
    //     gradeId: this.gradeId
    //   }).then(() => {
    //     this.$message.success(this.$t('public.sendSuccess'))
    //   })
    // },

    // 验证码时间
    // setCodeTime() {
    //   if (this.codeTime === 0) {
    //     this.haveCode = false
    //     return
    //   }

    //   setTimeout(() => {
    //     this.codeTime--
    //     this.setCodeTime()
    //   }, 1000)
    // },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true
      const editApi = this.gradeStatus
        ? this.$api.REEDITGRADE
        : this.$api.UPDATEGRADE
      this.$http(editApi, {
        campusId: this.campusId, // 学习中心ID
        academic: this.academic,
        comments: values.comments,
        courseId: this.courseId,
        score: values.score, //评分
        studentId: this.studentId, //学生ID
        term: this.exam, //学期
        userId: this.userId, //员工ID
        grade: this.classInfo.grade, //
        id: this.gradeId,
      })
        .then(() => {
          this.getDataSource()
          this.getStudentDataSource()
          this.$message.success(this.$t('public.saveSuccess'))
          this.modalVisible = false
          // this.haveCode = false
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.form.resetFields()
      this.gradeId = ''
      this.courseId = ''
      this.gradeStatus = false
      this.modalLoading = false
    },

    // 班主任评语
    getFeedback() {
      if (
        this.handleRightsList.includes('班主任反馈') &&
        this.academic &&
        this.exam &&
        this.studentId
      ) {
        this.$http(this.$api.GETFEEDBACKBYSTUDENTID, {
          academic: this.academic,
          term: this.exam,
          studentId: this.studentId,
        }).then((r) => {
          this.feedbackDataSource = r.data
            ? [
                {
                  id: r.data.id,
                  submitStatus: r.data.submitStatus,
                  comments: r.data.comments,
                },
              ]
            : [
                {
                  submitStatus: 0,
                  comments: '',
                },
              ]
        })
      }
    },

    // 编辑反馈
    editFeedback(record) {
      this.feedbackId = record.id
      this.feedbackModalVisible = true
      this.$nextTick().then(() => {
        this.feedbackForm.setFieldsValue({
          comments: record.comments,
        })
      })
    },

    feedbackOk() {
      this.feedbackForm.validateFields((err, values) => {
        if (!err) {
          this.handleSaveFeedback(values)
        }
      })
    },

    handleSaveFeedback(values) {
      this.feedbackModalLoading = true
      const editApi =
        this.feedbackDataSource[0].submitStatus !== 0
          ? this.$api.REEDITFEEDBACK
          : this.$api.UPDATEFEEDBACK
      this.$http(editApi, {
        campusId: this.campusId, // 学习中心ID
        academic: this.academic,
        comments: values.comments,
        studentId: this.studentId, //学生ID
        term: this.exam, //学期
        userId: this.userId, //员工ID
        grade: this.classInfo.grade,
        id: this.feedbackId,
      })
        .then(() => {
          this.getFeedback()
          this.getStudentDataSource()
          this.$message.success(this.$t('public.saveSuccess'))
          this.feedbackModalVisible = false
        })
        .catch(() => {
          this.feedbackModalLoading = false
        })
    },

    feedbackAfterClose() {
      this.feedbackForm.resetFields()
      this.feedbackId = ''
      this.feedbackModalLoading = false
    },
    //学号排序
    sorterStudentNo(a, b) {
      return (
        parseInt(a.studentNo.substring(a.studentNo.length - 3)) -
        parseInt(b.studentNo.substring(b.studentNo.length - 3))
      )
    },
    //英文排序
    sorterEnglishName(a, b) {
      return (a.englishName + '').localeCompare(b.englishName + '')
    },
    //中文排序
    sorterName(a, b) {
      return (a.givenName + '').localeCompare(b.givenName + '')
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';
/deep/ .ant-table-tbody {
  .name {
    margin-left: 8px;
    display: inline-block;
    padding: 2px 3px;

    color: white;
    border-radius: 5px;
  }
  .GRA {
    color: white;
    background-color: #707070;
  }
  //休学
  .QS {
    background-color: #ff9933;
  }
  //退学
  .DO {
    background-color: #ff6666;
  }
}
.term-grades-class {
  padding-top: 0;
  padding-bottom: 0;
  min-height: calc(~'100% - @{pageHeaderHeight}');
  display: flex;
  @timetableTypeWidth: 420px;
  .student-list {
    padding: 15px 0;
    margin-bottom: -30px;
    width: @timetableTypeWidth;
    padding-right: 10px;
    border-right: 1px solid @lineColor;
    .class-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .class-title {
        font-size: @titleFontSize;
        .back {
          font-size: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .student-grade {
    padding: 15px 0 0;
    width: calc(~'100% - @{timetableTypeWidth}');
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    .grade-title {
      font-size: @titleFontSize;
    }

    .cover-header {
      border: 1px solid @lineColor;
      border-bottom: 0;
      background-color: @backColor;
      height: 8px;
      margin: 10px 10px 0;
    }

    .cover-content {
      flex-grow: 1;
      border: 1px solid @lineColor;
      padding: 20px;

      .table-title {
        font-size: @titleFontSize;
        margin-bottom: 20px;
      }

      .student-name {
        font-weight: bold;
      }
    }
  }
  .grade-status {
    color: @themeColor;
  }

  .table-list-title {
    font-size: @titleFontSize;
    margin: 25px 0 10px;
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.grade-class-student {
  .subject-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
}
</style>
